// extracted by mini-css-extract-plugin
export var parcelRow = "_sr-0";